(function() {
  console.log('sticky-nav.js loaded');
  var subnav = document.querySelector('[data-subnav]');
  console.log('subnav element:', subnav);
  if (!subnav) return;

  var triggerPoint = subnav.offsetTop;

  function handleScroll() {
    if (window.scrollY >= triggerPoint) {
      subnav.style.position = 'fixed';
      subnav.style.top = '0';
    } else {
      subnav.style.position = 'relative';
      subnav.style.top = 'auto';
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
})();